import { useMemo } from 'react';
import { ConfigSvcProps } from '..';

export const useSvcDisabled = (props: ConfigSvcProps) => {
  const { formCache, isRequired, id, disabled } = props;
  const svcDisabled = useMemo(() => {
    return !isRequired && !formCache?.[id]?.name;
  }, [formCache, id, isRequired]);

  return svcDisabled || disabled;
};
